import { Avatar, Button, Divider, Grid, Typography } from "@material-ui/core";
import { GetApp } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import api from "../../services/api";
import Audio from "../Audio";
import LocationPreview from "../LocationPreview";
import VcardPreview from "../VcardPreview";
import VideoPlayerComponete from "../VideoPlayer";
import ModalContatos from "../ListaContatosModal";
import Skeleton from "@material-ui/lab/Skeleton";
import ImageWithSkeleton from "../ImageWithSkeleton";

const MessageMedia = ({ message }) => {
  const [listaContatos, setListaContatos] = useState([]);
  const [openModalListaContatos, setOpenModalListaContatos] = useState(false);

  useEffect(() => {
    if (message.mediaType === "multi_vcard") {
      const listaPrevia = [];
      const listaVCards = message.body
        .split("END:VCARD")
        .slice(0, -1)
        .map((v) => v + "END:VCARD");

      for (let i = 0; i < listaVCards.length; i++) {
        let array = listaVCards[i].split("\n");
        let obj = [];
        let contact = "";
        for (let index = 0; index < array.length; index++) {
          const v = array[index];
          let values = v.split(":");
          for (let ind = 0; ind < values.length; ind++) {
            if (values[ind].indexOf("+") !== -1) {
              obj.push({ number: values[ind] });
            }
            if (values[ind].indexOf("FN") !== -1) {
              contact = values[ind + 1];
            }
          }
        }

        listaPrevia.push({
          nomeContato: contact,
          numeroContato: obj[0]?.number,
        });
      }

      setListaContatos(listaPrevia);
    }
  }, [message]);

  if (message.mediaType === "location") {
    const [imageLocation, linkLocation, descriptionLocation] =
      message.body.split("|");
    return (
      <LocationPreview
        image={imageLocation}
        link={linkLocation}
        description={descriptionLocation}
      />
    );
  }

  if (message.mediaType === "vcard") {
    const array = message.body.split("\n");
    const obj = [];
    let contact = "";
    array.forEach((v) => {
      const values = v.split(":");
      if (values[1]?.includes("+")) obj.push({ number: values[1] });
      if (values[0]?.includes("FN")) contact = values[1];
    });
    return <VcardPreview contact={contact} numbers={obj[0]?.number} />;
  }

  if (message.mediaType === "multi_vcard") {
    const carregando = listaContatos.length === 0;

    return (
      <div style={{ minWidth: "250px" }}>
        <Grid container spacing={1}>
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {carregando ? (
              <Skeleton variant="circular" width={40} height={40} />
            ) : (
              <Avatar />
            )}
          </Grid>

          <Grid item xs={9}>
            {carregando ? (
              <Skeleton
                variant="text"
                width={160}
                height={40}
                style={{ marginTop: 12, marginLeft: 10 }}
              />
            ) : (
              <Typography
                style={{ marginTop: "12px", marginLeft: "10px" }}
                variant="subtitle1"
                color="primary"
                gutterBottom
              >
                {listaContatos[0]?.nomeContato || ""} <br />e mais{" "}
                {listaContatos.length - 1}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12}>
            <Divider />
            <Button
              fullWidth
              color="primary"
              disabled={carregando}
              onClick={() => setOpenModalListaContatos(true)}
            >
              Ver todos
            </Button>
          </Grid>
        </Grid>

        <ModalContatos
          isOpen={openModalListaContatos}
          onClose={() => setOpenModalListaContatos(false)}
          contatos={listaContatos}
        />
      </div>
    );
  }

  if (message.mediaType === "image") {
    return (
      <ImageWithSkeleton imageUrl={message.mediaUrl} body={message.body} />
    );
  }

  if (message.mediaType === "audio") {
    return <Audio url={message.mediaUrl} />;
  }

  if (message.mediaType === "video") {
    return (
      <>
        <VideoPlayerComponete mediaUrl={message.mediaUrl} />
        <Divider />
      </>
    );
  }

  if (
    String(message.body).endsWith(".pdf") ||
    String(message.body).endsWith(".xml") ||
    String(message.body).endsWith(".txt") ||
    String(message.body).endsWith(".rem")
  ) {
    const label = String(message.body).endsWith(".xml")
      ? "Download XML"
      : String(message.body).endsWith(".pdf")
      ? "Visualizar PDF"
      : "Download Arquivo";
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: 10 }}>
        <Button
          startIcon={<GetApp />}
          color="primary"
          variant="outlined"
          onClick={async () => {
            try {
              const { data, headers } = await api.get(
                "/obter-arquivo/" + message.mediaUrl,
                {
                  responseType: "blob",
                }
              );
              const blob = new Blob([data], { type: headers["content-type"] });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.download = message.body;
              link.click();
              window.URL.revokeObjectURL(url);
            } catch (err) {
              console.error("Erro ao abrir o arquivo:", err);
            }
          }}
        >
          {label}
        </Button>
      </div>
    );
  }

  if (
    message.mediaType === "application" ||
    message.mediaType === "text" ||
    message.mediaType === "rem"
  ) {
    const mediaType = String(message.mediaType);

    const label =
      mediaType === "application"
        ? "Download e Visualizar Arquivo"
        : "Download Arquivo";

    return (
      <div style={{ display: "flex", justifyContent: "center", padding: 10 }}>
        <Button
          startIcon={<GetApp />}
          color="primary"
          variant="outlined"
          onClick={async () => {
            try {
              const { data, headers } = await api.get(
                "/obter-arquivo/" + message.mediaUrl,
                {
                  responseType: "blob",
                }
              );
              const blob = new Blob([data], { type: headers["content-type"] });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.download = message.body;
              link.click();
              window.URL.revokeObjectURL(url);
            } catch (err) {
              console.error("Erro ao abrir o arquivo:", err);
            }
          }}
        >
          {label}
        </Button>
      </div>
    );
  }

  return null;
};

export default MessageMedia;
